//분실물 카드 UI (이름, 장소, 날짜, 상태)
import React from "react";
import "./LostItemCard.css";

function LostItemCard({ name, status, location, date, onClick }) {
  // 상태가 '습득'이면 pink '분실'이면 blue
  const badgeClass = status === "습득" ? "badge-found" : "badge-lost";

  return (
    <div className="lost-item-card" onClick={onClick} style={{ cursor: "pointer" }}>
      <div className="card-header">
        <h4 className="card-title">{name}</h4>
        <span className={`card-badge ${badgeClass}`}>{status}</span>
      </div>
      <div className="card-body">
        <p className="card-info">장소: {location}</p>
        <p className="card-info">날짜: {date}</p>
      </div>
    </div>
  );
}

export default LostItemCard;